import { ChevronUp, ChevronDown } from "lucide-react";
import { theme } from "@src/theme";

interface SortIconsProps {
  sortColumn: string;
  columnAccessor: string;
  sortOrder: "" | "asc" | "desc";
}

const SortIcons: React.FC<SortIconsProps> = ({
  sortColumn,
  columnAccessor,
  sortOrder,
}) => {
  const isActive = sortColumn === columnAccessor;
  const iconColor = isActive ? theme.colors.yellow : theme.colors.gray;

  return (
    <div style={{ display: "flex", flexDirection: "column", flexShrink: 0 }}>
      {isActive ? (
        sortOrder === "asc" ? (
          <ChevronUp size={18} color={iconColor} />
        ) : (
          <ChevronDown size={18} color={iconColor} />
        )
      ) : (
        <>
          <ChevronUp size={18} color={iconColor} />
          <ChevronDown size={18} color={iconColor} />
        </>
      )}
    </div>
  );
};

export default SortIcons;
